// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../node_modules/_css-loader@0.26.4@css-loader/index.js?minimize!../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/style-rewriter.js?id=data-v-27066d0e&scoped=true!../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=styles&index=0!./affix.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../node_modules/_vue-style-loader@2.0.5@vue-style-loader/lib/addStylesClient.js")("96580636", content, true);


//////////////////
// WEBPACK FOOTER
// ./~/_vue-style-loader@2.0.5@vue-style-loader!./~/_css-loader@0.26.4@css-loader?minimize!./~/_vue-loader@10.3.0@vue-loader/lib/style-rewriter.js?id=data-v-27066d0e&scoped=true!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=styles&index=0!./src/components/affix/src/affix.vue
// module id = 691
// module chunks = 0